import React, {  useContext, useState, useEffect } from 'react';
import { AuthContext } from './App';
import { useNavigate  } from 'react-router-dom';
import axios from 'axios';
import { ChevronDownIcon } from '@heroicons/react/solid';

function Profile() {
    const [bookmarks, setBookmarks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 2;
    const { auth } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (auth.isLoggedIn) {
            fetchBookmarks();
        }
    }, [auth.isLoggedIn, currentPage]);
    
    const handleCardClick = (documentId) => {
        navigate(`/jobOffer/${documentId}`);
    };

    const fetchBookmarks = async () => {
        try {
            const response = await axios.get(`http://localhost:5000/auth/user/${auth.user}/profile-bookmarks`);
            setBookmarks(response.data);
        } catch (error) {
            console.error("Failed to fetch bookmarks:", error);
        }
    };

    const toggleBookmark = async (documentId, offerId, e) => {
        e.stopPropagation(); // Prevent card click when clicking the button
        if (!auth.isLoggedIn) {
            alert("Please log in to bookmark jobs.");
            return;
        }
        try {
            await axios.post(`http://localhost:5000/auth/toggle-bookmark`, {
                userId: auth.user,
                documentId,
                offerId
            });
            fetchBookmarks();
        } catch (error) {
            console.error('Failed to toggle bookmark:', error);
        }
    };

    const totalPages = Math.ceil(bookmarks.length / itemsPerPage);
    const currentData = bookmarks.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <div className="min-h-screen flex justify-center items-start pt-10 pb-10"> {/* Vertical padding for some space from top and bottom */}
            <div className="w-full max-w-6xl overflow-hidden"> {/* Constrained width with some shadow and rounded corners */}
                <div className="flex">
                    <div className="w-5/6 bg-white dark:bg-gray-800 p-4 overflow-auto">
                        <h2>My Bookmarked Offers</h2>
                        <div className="results-container">
                            {currentData.map((jobOffer, index) => (
                                <div key={index} className="job-card" onClick={() => handleCardClick(jobOffer.documentId)}>
                                    <div className="job-info">
                                        <div className="company">{jobOffer.company}</div>
                                        <div>{jobOffer.title}</div>
                                        <div>{jobOffer.location}</div>
                                    </div>
                                    <div className="job-salary">
                                        <div className="amount">${jobOffer.baseSalary}</div>
                                        <div className="stock-options">{jobOffer.stockOptions}</div>
                                    </div>
                                    <div className="status">{jobOffer.status}</div>
                                    <button onClick={(e) => toggleBookmark(jobOffer.documentId, jobOffer.offerId, e)}>
                                        {bookmarks.findIndex(b => b.documentId === jobOffer.documentId && b.offerId === jobOffer.offerId) !== -1 ? 'Unbookmark' : 'Bookmark'}
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-between items-center mt-4">
                            {currentPage > 1 && (
                                <button onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                            )}
                            {Array.from({ length: totalPages }, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => setCurrentPage(i + 1)}
                                    className={currentPage === i + 1 ? 'active' : ''}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            {currentPage < totalPages && (
                                <button onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
// import React, { useContext, useState, useEffect } from 'react';
// import { AuthContext } from './App';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// function Profile() {
//     const { auth } = useContext(AuthContext);
//     const navigate = useNavigate();
//     const [bookmarkedOffers, setBookmarkedOffers] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10; // You can adjust this value to show more or less items per page

//     useEffect(() => {
//         if (auth.isLoggedIn) {
//             fetchBookmarks();
//         }
//     }, [auth.isLoggedIn, currentPage]); // Refetch when user logs in or page changes

//     const fetchBookmarks = async () => {
//         try {
//             const response = await axios.get(`http://localhost:5000/auth/user/${auth.user}/bookmarks`);
//             setBookmarkedOffers(response.data);
//             console.log(response.data); // Log the data to console for inspection
//             // Assuming that each response includes all the bookmarks, no backend pagination implemented
//         } catch (error) {
//             console.error("Failed to fetch bookmarks:", error);
//         }
//     };

//     const handlePageChange = (newPage) => {
//         setCurrentPage(newPage);
//     };

//     const handleUnbookmark = async (documentId, offerId) => {
//         try {
//             await axios.post(`http://localhost:5000/auth/toggle-bookmark`, {
//                 userId: auth.user,
//                 documentId,
//                 offerId
//             });
//             fetchBookmarks(); // Refetch bookmarks to update the list after removal
//         } catch (error) {
//             console.error('Failed to toggle bookmark:', error);
//         }
//     };

//     const totalPages = Math.ceil(bookmarkedOffers.length / itemsPerPage);
//     const currentData = bookmarkedOffers.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//     );

//     return (
//         <div>
//             <h2>My Bookmarked Offers</h2>
//             {/* Raw JSON output for debugging */}
//             <pre>{JSON.stringify(currentData, null, 2)}</pre>
//             <div className="pagination">
//                 {currentPage > 1 && (
//                     <button onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
//                 )}
//                 {Array.from({ length: totalPages }, (_, i) => (
//                     <button
//                         key={i + 1}
//                         onClick={() => setCurrentPage(i + 1)}
//                         className={currentPage === i + 1 ? 'active' : ''}
//                     >
//                         {i + 1}
//                     </button>
//                 ))}
//                 {currentPage < totalPages && (
//                     <button onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
//                 )}
//             </div>
//         </div>
//         // <div>
//         //     <h2>My Bookmarked Offers</h2>
//         //     <div className="results-container">
//         //         {currentData.map((offer, index) => (
//         //             <div key={index}>
//         //                 <div className="job-info">
//         //                         <div className="company">{jobOffer.company}</div>
//         //                         <div>{jobOffer.title}</div>
//         //                         <div>{jobOffer.location}</div>
//         //                     </div>
//         //                     <div className="job-salary">
//         //                         <div className="amount">${jobOffer.baseSalary}</div>
//         //                         <div className="stock-options">{jobOffer.stockOptions}</div>
//         //                     </div>
//         //                 <button onClick={() => handleUnbookmark(offer.documentId, offer._id)}>
//         //                     Unbookmark
//         //                 </button>
//         //             </div>
//         //         ))}
//         //     </div>
//         //     <div className="pagination">
//         //         {currentPage > 1 && (
//         //             <button onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//         //         )}
//         //         {Array.from({ length: totalPages }, (_, i) => (
//         //             <button
//         //                 key={i + 1}
//         //                 onClick={() => handlePageChange(i + 1)}
//         //                 className={currentPage === i + 1 ? 'active' : ''}
//         //             >
//         //                 {i + 1}
//         //             </button>
//         //         ))}
//         //         {currentPage < totalPages && (
//         //             <button onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//         //         )}
//         //     </div>
//         // </div>
//     );
// }

// export default Profile;

// // import React, { useContext, useState, useEffect } from 'react';
// // import { AuthContext } from './App';
// // import axios from 'axios';

// // function Profile() {
// //     const { auth } = useContext(AuthContext);
// //     const [bookmarks, setBookmarks] = useState({});
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [totalPages, setTotalPages] = useState(0);

// //     useEffect(() => {
// //         if (auth.isLoggedIn) {
// //             fetchBookmarks();
// //         }
// //     }, [currentPage, auth.isLoggedIn, currentPage]);

// //     const handleCardClick = (documentId) => {
// //         navigate(`/jobOffer/${documentId}`);
// //     };

// //     const fetchBookmarks = async () => {
// //         try {
// //             const response = await axios.get(`http://localhost:5000/auth/user/${auth.user}/bookmarks`);
// //             const newBookmarks = {};
// //             response.data.forEach(jobOffer => {
// //                 jobOffer.offers.forEach(offer => {
// //                     if (!newBookmarks[jobOffer._id]) {
// //                         newBookmarks[jobOffer._id] = new Set();
// //                     }
// //                     newBookmarks[jobOffer._id].add(offer._id.toString());
// //                 });
// //             });
// //             setBookmarks(newBookmarks);
// //         } catch (error) {
// //             console.error("Failed to fetch bookmarks:", error);
// //         }
// //     };

// //     const toggleBookmark = async (documentId, offerId, e) => {
// //         e.stopPropagation(); // Prevent card click when clicking the button
// //         if (!auth.isLoggedIn) {
// //             alert("Please log in to bookmark jobs.");
// //             return;
// //         }
// //         try {
// //             await axios.post(`http://localhost:5000/auth/toggle-bookmark`, {
// //                 userId: auth.user,
// //                 documentId,
// //                 offerId
// //             });
// //             const newBookmarks = { ...bookmarks };
// //             if (!newBookmarks[documentId]) {
// //                 newBookmarks[documentId] = new Set();
// //             }
// //             if (newBookmarks[documentId].has(offerId)) {
// //                 newBookmarks[documentId].delete(offerId);
// //             } else {
// //                 newBookmarks[documentId].add(offerId);
// //             }
// //             setBookmarks(newBookmarks); // Trigger re-render
// //         } catch (error) {
// //             console.error('Failed to toggle bookmark:', error);
// //         }
// //     };

// //     const handlePageChange = (newPage) => {
// //         setCurrentPage(newPage);
// //     };

// //     return (
        
// //         <div className="profile-container">
// //             <div className="results-container">
// //                 {results.map((jobOffer, index) => (
// //                     <div key={index} className="job-card" onClick={() => handleCardClick(jobOffer.documentId)}>
// //                         <div className="job-info">
// //                             <div className="company">{jobOffer.company}</div>
// //                             <div>{jobOffer.title}</div>
// //                             <div>{jobOffer.location}</div>
// //                         </div>
// //                         <div className="job-salary">
// //                             <div className="amount">${jobOffer.baseSalary}</div>
// //                             <div className="stock-options">{jobOffer.stockOptions}</div>
// //                         </div>
// //                         <div className="status">{jobOffer.status}</div>
// //                         <button onClick={(e) => toggleBookmark(jobOffer.documentId, jobOffer.offerId, e)}>
// //                             {bookmarks[jobOffer.documentId]?.has(jobOffer.offerId.toString()) ? 'Unbookmark' : 'Bookmark'}
// //                         </button>
// //                     </div>
// //                 ))}
// //             </div>
// //             <div className="pagination">
// //                 <button onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
// //                         disabled={currentPage === 1}
// //                         className="pagination-button">
// //                     Previous
// //                 </button>
// //                 {[...Array(totalPages).keys()].map(pageNumber => (
// //                     <button key={pageNumber} onClick={() => handlePageChange(pageNumber + 1)}
// //                             className={`pagination-button ${currentPage === pageNumber + 1 ? 'active' : ''}`}>
// //                         {pageNumber + 1}
// //                     </button>
// //                 ))}
// //                 <button onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
// //                         disabled={currentPage === totalPages}
// //                         className="pagination-button">
// //                     Next
// //                 </button>
// //             </div>
// //         </div>
// //     );
// // }

// // export default Profile;
